import Vue from 'vue'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css'; // 引入Element UI样式

import 'normalize.css/normalize.css'
import '@/styles/index.less'
import App from './App.vue'
import store from './store'
import router from './router'

import './permission'
import { i18n } from './i18n/index' //国际化

Vue.config.productionTip = false

Vue.use(ElementUI);

// new Vue({
//   render: h => h(App),
// }).$mount('#app')

new Vue({
  el: '#app',
  router,
  store,
  i18n,
  render: h => h(App)
})
